
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/broken-pipe",
      function () {
        return require("private-next-pages/services/broken-pipe.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/broken-pipe"])
      });
    }
  